<template lang="pug">
  v-dialog(v-model='dialogDetalleOrd', persistent='', max-width='80%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline Orden # {{ordenesAux.codigoOrd}}
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined readonly v-model='ordenesAux.fechaCyEOrd' label='Fecha cierre y envío' prepend-inner-icon='event')
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(v-if='ordenesAux.proveedorOrd' dense outlined readonly v-model='ordenesAux.proveedorOrd.nombre' label='Proveedor')
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined readonly v-model='ordenesAux.totalOrd' label='Monto FOB' prefix="$")
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined :readonly='read' v-model='ordenesAux.facturaProvOrd' label='# Factura Proveedor')
                v-row(dense)
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined :readonly='read' v-model='ordenesAux.kilogramosOrd' label='Total Peso' suffix="Kg")
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined :readonly='read' v-model='ordenesAux.piesCubicosOrd' label='Total Pies Cúbicos' suffix="ft³")
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined readonly v-model='ordenesAux.metroCubicoOrd' label='Total Metro Cúbicos' suffix="m³")
                  v-col(cols='6' sm='6' md='3')
                    v-text-field(dense outlined :readonly='read' v-model='ordenesAux.piezasOrd' label='Cantidad de Piezas')
                v-row(dense)
                  v-col(cols='12' sm='12' md='12')
                    v-textarea(auto-grow dense outlined :readonly='read' v-model='ordenesAux.descripcionProdOrd' label='Descripción de Productos')
      v-card-actions
        v-btn(color='error' small dark @click='closeDetalleOrd')
          v-icon mdi-close
          | Cancelar
        v-spacer
        v-btn(color='success' v-if="read === false" style="margin-right: 1%" dark small @click='asignar')
          v-icon mdi-content-save
          | Asignar
</template>

<script>
import { EventBus } from '../../Events'
export default {
  props: ['dialogDetalleOrd'],
  data: () => ({
    dialog: false,
    ordenesAux: {},
    ordenes: {},
    read: false,
    modificar: false
  }),

  watch: {},

  created () {
    EventBus.$on('dataDetalleOrd', data => {
      this.ordenesAux = data.ordenesAux
      this.read = data.read
    })
  },

  methods: {
    closeDetalleOrd () {
      this.$emit('closeDetalleOrd')
    },

    asignar () {
      this.ordenes = this.ordenesAux
      this.$emit('asignar', this.ordenes)
      this.ordenesAux = {}
    }
  }
}
</script>
